<app-modal-container
  [title]="modalType === 'create' ? 'Create fund' : (modalType === 'update' ? 'Edit fund' : 'Duplicate fund: ' + fund.name)"
  [buttons]="modalButtons"
  [spinnerProps]="spinnerProps"
  [applyActivated]="selectedFundForm.valid"
  (applyButtonClicked)="confirm()"
  (closeButtonClicked)="closeModal.emit(false)"
  (dismissButtonClicked)="closeModal.emit(false)"
  (lowerLeftButtonClicked)="showFundDeleteModal = true">

  <form [formGroup]="selectedFundForm" class="row-container row-gap-1">
    <div class="modal-column-width vertical-container-simple column-gap-1p5625">
      <app-input
        data-qa="fund-name"
        [required]=true
        [title]="'Fund name'"
        [formControlName]="'name'"
        [additionalClass]="additionalClass.name">
      </app-input>
      <div class="position-rel">
      <app-input *ngIf="orgAccess.isSuperAdmin || orgAccess.isOrganizationAdmin"
        data-qa="fund-id"
        [required]=true
        [title]="'Fund ID'"
        [regularExpression]="regExpService.partialNotNegativeDecimalNumbersOrEmpty"
        [formControlName]="'fundId'"
        [additionalClass]="(additionalClass.fundId) || (selectedFundForm.controls.fundId.invalid ? 'error' : '')"
        (blurEmitter)="checkFundId()">
      </app-input>
      <span  class="position-abs abs-top-105pcnt caption-2 opacity0p64 bold500 ">Should match investor portal </span>
    </div>
      <app-input *ngIf="orgAccess.isSuperAdmin || orgAccess.isOrganizationAdmin"
        data-qa="reg-number"
        [title]="'Registration number'"
        [formControlName]="'registrationNumber'">
      </app-input>
      <app-selector-autocomplete
        data-qa="fund-reg-state"
        [title]="'Registration state'"
        [data]="countries"
        [isInsideModal]="true"
        [formControlName]="'registration'">
      </app-selector-autocomplete>
      <div  class="position-rel">
      <app-input
        data-qa="fund-totalopex"
        [title]="'Total expected OpEx'"
        [separator]="'separator.2'"
        [thousandSeparator]="','"
        [formControlName]="'expectedOpEx'"
        [suffix]="'%'">
      </app-input>
      <span  class="position-abs abs-top-105pcnt  caption-2 opacity0p64 bold500 ">Till liquidation</span>
      </div>
      <app-selector
        [title]="'Management company'"
        [data]="managementCompanies"
        [selectedItem]="selectedManagementCompany"
        [field]="'name'"
        [selectedOption]="'Select'"
        [isNotInTable]="true"
        (itemEmitter)="selectedManagementCompanyUUID = $event.uuid">
      </app-selector>
      <div class="flex gap-0.15625">
        <app-checkbox
          data-qa="spv-checkbox"
          [checked]="selectedFundForm.value.spv"
          (change)="selectedFundForm.patchValue({ spv: !selectedFundForm.value.spv })">
        </app-checkbox>
        <span>SPV</span>
      </div>
    </div>
    <div class="modal-column-width vertical-container-simple column-gap-1p5625">
      <app-input
        data-qa="fund-reg-date"
        [title]="'Registration date'"
        [dateInput]="true"
        [formControlName]="'registrationDate'">
      </app-input>
      <app-input
        data-qa="fund-init-closing"
        [title]="'Initial closing'"
        [dateInput]="true"
        [formControlName]="'initialClosing'">
      </app-input>
      <div class="count-input-wrapper">
        <button class="servc-button info small-size" (click)="showModalFundTerm('Final closing')">
          Count
        </button>
        <app-input
          data-qa="fund-final-closing"
          [title]="'Final closing'"
          [dateInput]="true"
          [formControlName]="'finalClosing'">
        </app-input>
      </div>
      <div class="count-input-wrapper">
        <button class="servc-button info small-size" (click)="showModalFundTerm('Investment period')">
          Count
        </button>
        <app-input
          data-qa="fund-period"
          [title]="'Investment period'"
          [dateInput]="true"
          [formControlName]="'investmentPeriod'">
        </app-input>
      </div>
      <div class="count-input-wrapper">
        <button class="servc-button info small-size" (click)="showModalFundTerm('Fund term')">
          Count
        </button>
        <app-input
          data-qa="fund-term"
          [dateInput]="true"
          [title]="'Fund term'"
          [formControlName]="'fundTerm'">
          [dateInput]="true">
        </app-input>
      </div>
      <div>
        <div  class="position-rel">
        <app-input
          data-qa="fund-investlim"
          [title]="'Investment limit'"
          [separator]="'separator.2'"
          [thousandSeparator]="','"
          [formControlName]="'investmentLimit'"
          [suffix]="'%'">
        </app-input>
        <span  class="position-abs abs-top-105pcnt caption-2 opacity0p64 bold500 ">Per company </span>
        </div>
      </div>
      <div [ngClass]="modalType === 'update' ? 'action-block-update': 'action-block-create'">
        <app-modal-dialog *ngIf="showFundDeleteModal"
          [header]="'Delete fund'"
          [useStandardList]="true"
          [innerModal]="true"
          (isConfirmed)="closeDeleteModal($event)">
        </app-modal-dialog>
      </div>
    </div>
  </form>
  <app-modal-fund-term *ngIf="showFundTermsModal"
    [fund]="selectedFundForm.value"
    [countedPeriodType]="countedPeriodType"
    (closeModal)="showFundTermsModal = false"
    (confirm)="setCountedPeriod($event)" >
  </app-modal-fund-term>
</app-modal-container>
